// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:IDENTITY
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:view/community/designer_assets_prompt_dialog':
    'DesignerAssetsPromptDialog',
  'minted:view/community/user_terms_agreement': 'UserTermsAgreement',
  'minted:model/community/user_terms_agreement': 'UserTermsAgreement'
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;

  /**
   * @class M.View.Community.UserNotificationPopups
   *
   */
  M.View.Community.UserNotificationPopups = Backbone.View.extend({

    initialize: function() {
      M.required(this.options.assetsUrlPaths);
      M.required(this.options.termsTitle);

      var assetPromptDialog =
        new M.View.Community.DesignerAssetsPromptDialog({
         urlPaths: this.options.assetsUrlPaths
        });

      var termsAndAgreementModel = new M.Model.Community.UserTermsAgreement({
       nodeTitle: this.options.termsTitle,
       showReviewLaterButton: false
      });

      var termsView = new M.View.Community.UserTermsAgreement({
       model: termsAndAgreementModel
      });
    }

  });

  return { };

});
